module.exports = __webpack_public_path__ + "static/media/fazal.fefa7b13.jpg";